export default __webpack_public_path__ + "static/media/reset.06533c0b.svg";